export default {
    "POST": {
        "POST": "Post",
        "SLUG": "URL",
        "TITLE": "Title",
        "CONTENT": "Content",
        "COLOR": "Color",
        "CATEGORY": "Category",
        "CATEGORIES": "Categories",
        "EXCERPT": "Excerpt",
        "CATEGORY_NAME": "Category name",
        "ADDRESS": "Address",
        "PHONE": "Phone",
        "MAIL": "Email",
        "ORDER": "Order",
        "PINNED": "Pinned",
        "PUBLISH": "Publish",
        "UNPUBLISH": "Unpublish",
        "SCHEDULE_AT": "Schedule",
        "CREATED_AT": "Date",
        "IS_FOOTER": "On Footer",
        "POST_TAG": "News category",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/en/post.js